import React, { useState } from 'react';
import { Modal } from 'antd';
import weixinQR from '../assets/weixin.jpg';
import '../styles/CustomerServiceFloat.css';

const CustomerServiceFloat: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      {/* 客服浮窗按钮 */}
      <div className="customer-service-float" onClick={showModal}>
        <div className="service-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" fill="currentColor"/>
          </svg>
        </div>
        <div className="service-label">客服</div>
      </div>

      {/* 微信二维码弹窗 */}
      <Modal
        title="添加小助手微信"
        open={isModalVisible}
        onCancel={handleClose}
        footer={null}
        centered
        width={320}
        className="weixin-modal"
      >
        <div className="weixin-content">
          <img src={weixinQR} alt="微信二维码" className="weixin-qr" />
          <p className="weixin-tip">扫描二维码添加小助手微信</p>
          <p className="weixin-desc">获取更多关系分析咨询和专业指导</p>
        </div>
      </Modal>
    </>
  );
};

export default CustomerServiceFloat;
